import React from 'react'
import { UpgradeItem, UpgradeItemLink } from 'components/Header/Styled'

const UpgradeCTAIcon = () => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M6 0L7.6 4.4L12 6L7.6 7.6L6 12L4.4 7.6L0 6L4.4 4.4L6 0Z' fill='white' />
  </svg>
)

const UpgradeCta = ({ EligibleForUpgrade, isSubscribed, hasListing }) => {
  if (EligibleForUpgrade && isSubscribed === false && hasListing) {
    return (
      <UpgradeItem>
        <UpgradeCTAIcon />
        <UpgradeItemLink href='/upgrade'>UPGRADE</UpgradeItemLink>
      </UpgradeItem>
    )
  }
  return null
}

export default UpgradeCta
